var cookie;
var domain;
var forms;
var host;
var referrer;

document.onreadystatechange = function () {
    if (document.readyState === "interactive") {
        psxCookie();
    }

    forms = document.getElementsByTagName('form');

    for (var i=0; i < forms.length; i++) {
        if (forms[i].addEventListener) {
            forms[i].addEventListener("submit", function (e){
                console.log(getCookie("mtc_sid"));
            }, false);
        } else {
            forms.attachEvent("onsubmit", function (e) {
                console.log(getCookie("mtc_sid"));
            });
        }
    }
};

function psxCookie() {
    host = window.location.hostname;
    referrer = document.referrer;

    cookie = checkCookie("PSXD-referrer");

    if ( ! cookie) {
        if (referrer) {
            domain = referrer.match(/:\/\/(.[^/]+)/)[1];

            if (domain && domain !== host) {
                cookie = checkCookie("PSXD-referrer");

                if ( ! cookie) {
                    setCookie("PSXD-referrer", domain, 365);
                    cookie = checkCookie("PSXD-referrer");
                }
            }
        }
    }

    console.log("COOKIE: " + cookie);
}

function checkCookie(name) {
    var referrerCookie = getCookie(name);
    if (referrerCookie !== "") {
        return referrerCookie;
    }

    return false;
}

function checkDiscounts(domain, host) {
    var data = {
        domain: domain,
        host: host
    };

    jQuery.ajax({
        data: data,
        dataType: "json",
        type: "GET",
        url: "https://psxdigital.com/powersports-marketing-automation/api/check-discounts",
        success: function (response) {
            console.log(response);
        },
        error: function (response) {
            console.log(response);
        }
    });
}

function getCookie(name) {
    var cname = name + "=";
    var decoded = decodeURIComponent(document.cookie);
    var cookies = decoded.split(';');

    for(var i = 0; i < cookies.length; i++) {
        var c = cookies[i];
        if (c.indexOf(cname) >= 0) {
            return c.substring(cname.length + 1, c.length);
        }
    }

    return "";
}

function setCookie(name, value, expireDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expireDays*24*60*60*1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}